import '../App.css';
import Mecka from '../assets/Mecka.png';
import FDM from '../assets/FDM.png';
import Geotab from '../assets/Geotab.png';
import Codepxl from '../assets/Codepxl.jpg';

const Experiences = () => {
    return (
        <div id='section-2' className="Experiences">
            <div className='Header'>
                EXPERIENCES
            </div>
            <div className='Section'>
                <div className='Centered'>
                <div className='List'>
                    <div className='Experience'>
                    <img src={FDM} alt='FDM' style={{ width: '75px', height: '75px', border: '2px solid #708090', borderRadius: '10px'}}></img>
                    <div className='Descriptions'>
                        <div className='Desc_header'>
                        <div className='Desc_title'>
                            Software Engineer Consultant
                        </div>
                        <div className='Desc_duration'>
                            Sep 2025 - Present
                        </div>
                        </div>
                        <div className='Desc_job'>
                        FDM
                        </div>
                        <div className='Points'>
                        • Strengthening expertise in <b>OOP, SQL, Spring, React, GCP,</b> and <b>Docker</b> to deliver effective, scalable software engineering solutions for clients
                        </div>
                    </div>
                    </div>
                    <div className='Experience'>
                    <img src={Mecka} alt='Mecka AI' style={{ width: '75px', height: '75px', border: '2px solid #708090', borderRadius: '10px'}}></img>
                    <div className='Descriptions'>
                        <div className='Desc_header'>
                        <div className='Desc_title'>
                            Project Manager
                        </div>
                        <div className='Desc_duration'>
                            Aug 2025 - Sep 2025
                        </div>
                        </div>
                        <div className='Desc_job'>
                        Mecka AI
                        </div>
                        <div className='Points'>
                        • Spearheaded improvements to Mecka AI’s <b>internal web application</b>, streamlining the data collection workflow
                        and reducing operational inefficiencies by <b>30%</b><br/>
                        • Oversaw <b>budget allocation, vendor relationships,</b> and <b>resource planning</b> for <b>3+</b> concurrent projects<br/>
                        • Represented Mecka AI in securing partnerships with <b>10+ businesses</b> for on-site AI training data collection,
                        fostering long-term collaboration and trust<br/>
                        • Monitored deliverable pipelines, generating statistics on <b>volume, quality, and rate of submission</b> to support
                        <b>deadline-driven decision making</b>
                        </div>
                    </div>
                    </div>
                    <div className='Experience'>
                    <img src={Geotab} alt='Geotab Inc.' style={{ width: '9%', border: '2px solid #708090', borderRadius: '10px'}}></img>
                    <div className='Descriptions'>
                        <div className='Desc_header'>
                        <div className='Desc_title'>
                            Software Engineer - Intern
                        </div>
                        <div className='Desc_duration'>
                            Sep 2023 - Aug 2024
                        </div>
                        </div>
                        <div className='Desc_job'>
                        Geotab Inc.
                        </div>
                        <div className='Points'>
                        • Improved <b>REST API</b> call response times by <b>78%</b> and resolved potential security vulnerabilities by restructuring
                        endpoints and associated DTOs with <b>C#</b> and <b>.Net</b><br/>
                        • Contributed to the migration of over <b>2500+</b> lines of legacy <b>AngularJS</b> code to <b>React and TypeScript</b>,
                        enforcing consistency and readability standards<br/>
                        • Reduced data search load times by <b>75%</b> via implementing server-side cursor-based pagination with <b>React</b> and
                        <b>PostgreSQL</b><br/>
                        • Optimized background process <b>PostgreSQL</b> queries by <b>90%</b> via streamlining JOIN operations, and identifying
                        and implementing <b>5+</b> new indexes<br/>
                        • Enhanced filter search UX by building a <b>multi-select search feature</b> with <b>dynamic chips</b> using React
                        and TypeScript, resulting in a more intuitive and efficient user experience<br/>
                        • Used <b>Google BigQuery</b> on <b>GCP</b> for E2E tests and data lookups across <b>100k+</b> log entries, streamlining QA
                        workflows and enabling quicker insights during test cycles
                        </div>
                    </div>
                    </div>
                    <div className='Experience'>
                    <img src={Codepxl} alt='Codepxl Inc.' style={{ width: '9%', border: '2px solid #708090', borderRadius: '10px'}}></img>
                    <div className='Descriptions'>
                        <div className='Desc_header'>
                        <div className='Desc_title'>
                            Software Engineer - Intern
                        </div>
                        <div className='Desc_duration'>
                            June 2022 - Dec 2022
                        </div>
                        </div>
                        <div className='Desc_job'>
                        Codepxl Inc.
                        </div>
                        <div className='Points'>
                        • Designed and developed data manipulation algorithms using <b>MySQL</b> and <b>PHP</b>, resulting in a <b>60x</b> improvement
                        in table management processes on a production database<br/>
                        • Developed <b>over 70 frames</b> of custom UI and core functionality using <b>JavaScript</b> and <b>CSS</b>, delivering high-
                        quality pages that exceeded the client’s requirements<br/>
                        • Built secure and efficient <b>REST APIs</b> for user authentication and access control using <b>Laravel Passport</b>,
                        meeting industry-standard OAuth2.0 requirements<br/>
                        • Successfully delivered a <b>React Native</b> mobile app through all stages of the development cycle, delivering the
                        project 2 weeks ahead of the client’s deadline<br/>
                        • Analyzed user requirements and worked with designers and clients to create detailed entity-relationship diagrams 
                        for <b>over 40 tables</b>, resulting in a comprehensive and efficient database structure
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default Experiences;